import React, { useEffect, useRef, useState } from 'react';
import Collapse, { Panel } from 'rc-collapse';
import {
  Wrapper,
  Content,
  StyledTitle,
  AccordionHeader,
  AccordionTitle,
  AccordionContent,
  GreenLink
} from './styles';

interface Props {
  data: {
    question: any;
    answer: any;
  }[];
}

export default function FAQ({ data = [] }: Props) {
  const [offset, setOffset] = useState(-90);
  const timeout = useRef<number>(0);

  useEffect(() => {
    if (window.innerWidth <= 997) {
      setOffset(-81);
    }
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);

  return (
    <Wrapper>
      <Content>
        <StyledTitle>Dúvidas frequentes</StyledTitle>
        <Collapse accordion>
          {data.map(({ question, answer }, index) => (
            <Panel
              header={
                <AccordionHeader>
                  <AccordionTitle>{question}</AccordionTitle>
                </AccordionHeader>
              }
              key={index}
              showArrow={false}
            >
              <AccordionContent>{answer}</AccordionContent>
            </Panel>
          ))}
        </Collapse>
        <GreenLink
          href="https://nexodata.zendesk.com/hc/pt-br"
          rel="noopener noreferrer"
          tabIndex={0}
          target="_blank"
          title="Ajuda"
        >
          Ainda tem dúvidas de como podemos te ajudar?{' '}
          <strong>Acesse nossa central de dúvidas</strong>
        </GreenLink>
      </Content>
    </Wrapper>
  );
}
